export const REGISTRATION_LINK =
  "https://forms.yandex.ru/cloud/6a4183269029020631e0253f";

export const conference = {
  title: "Общественные науки: исследования и практики",
  edition: "VIII МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ",
  topic: "«СТРАТЕГИИ РАЗВИТИЯ ОБЩЕСТВА И ЭКОНОМИКИ В НОВОЙ РЕАЛЬНОСТИ»",
  startsAt: "2026-10-15T10:00:00",
  programFile: "/assets/Программа_конференции_2026.pdf",
};
